import { trackPromise } from 'react-promise-tracker'
import { parseResponse, responseTypes } from '../../lib'

import log from 'loglevel'
import { loaderArea } from '../../utils'

const apiPath = process.env.REACT_APP_API_URL

// Get PDF version of assessment report and return as download
export const getAssessmentReportPDF = (reportID, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    try {
      const { token = '' } = getState().auth

      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await trackPromise(window.fetch(`${apiPath}/api/report/${reportID}`, options))

      const parsedResponse = parseResponse(response, dispatch)

      if (parsedResponse && parsedResponse.type === responseTypes.SUCCESS) {
        const { data } = await response.json()
        return data
      }

      fireFailure()
      return false
    } catch (error) {
      log.error(error)
      fireFailure()
      return false
    }
  }
}

// Share PDF version of assessment report with provided email address
export const shareAssessmentReportPDF = (reportID, emailAddress, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    try {
      const { token = '' } = getState().auth

      const body = { email: emailAddress }

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${apiPath}/api/report/${reportID}/share`, options), loaderArea.SHARE_ASSESSMENT_REPORT)
      const parsedResponse = parseResponse(response, dispatch)

      if (parsedResponse && parsedResponse.type === responseTypes.SUCCESS) {
        fireSuccess()
        return true
      }

      fireFailure()
      return false
    } catch (error) {
      log.error(error)
      fireFailure()
      return false
    }
  }
}

export const downloadPDF = (st, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    try {
      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${st}`
        }
      }

      const response = await trackPromise(window.fetch(`${apiPath}/api/pdf/download`, options), loaderArea.ASSESSMENT_DOWNLOAD)
      const parsedResponse = parseResponse(response, dispatch)

      if (parsedResponse && parsedResponse.type === responseTypes.SUCCESS) {
        const { data, name } = await response.json()

        if (!data && !name) { fireFailure(parseResponse) }

        fireSuccess({ data, name })

        return true
      }

      fireFailure()
      return false
    } catch (error) {
      log.error(error)
      fireFailure()
      return false
    }
  }
}
